import { render, staticRenderFns } from "./PropertyView.vue?vue&type=template&id=41edb37d"
import script from "./PropertyView.vue?vue&type=script&lang=ts"
export * from "./PropertyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports